export default function matchAndReturn<TOption extends string | number | symbol, TOptionReturn>(
	option: TOption,
	options: Record<TOption, TOptionReturn>,
): TOptionReturn {
	return options[option];
}
